import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { Col } from 'react-bootstrap'
import DatePicker from '../../../LaridaeApp/datepicker/container/DatePicker'
import { actualizarHistogramaVolcadoras } from '../../actions/HistogramaActions'
import { HistogramaVolcadorasView } from '../../components/histogramas/HistogramaVolcadorasView'

function HistogramaVolcadoras (props) {
  const { showCalendar = true, actualizarHistogramaVolcadoras } = props

  useEffect(() => {
    actualizarHistogramaVolcadoras(new Date(), new Date())
  }, [actualizarHistogramaVolcadoras])

  const actualizarfechas = (fechaD, fechaH) => {
    props.actualizarHistogramaVolcadoras(fechaD, fechaH)
  }

  return (
    <div style={{ display: 'flex', flexDirection: 'column' }}>
      {showCalendar
        ? <Col md={4} style={{ margin: '12px auto', float: 'right' }}>
          <DatePicker
            style={{ width: '95%' }}
            disabledFuture
            selectRange
            locale='es'
            onDateChange={actualizarfechas}
            titulo='Seleccione las fechas'
          />
        </Col>
        : null
      }

      <HistogramaVolcadorasView />
    </div>
  )
}

const mapActionsToProps = {
  actualizarHistogramaVolcadoras
}

const withRedux = connect(null, mapActionsToProps)
export default withRedux(HistogramaVolcadoras)
